"use strict";

exports.__esModule = true;
exports.ChatMessage = exports.ChatMessages = exports.CreateChatRoom = exports.ChatRoom = exports.ChatRooms = exports.NewMessage = exports.Notices = exports.SubscriptionProvider = exports.ContextProvider = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./styles/less/styles.css");

var _SubscriptionProvider = require("./components/SubscriptionProvider");

var _SubscriptionProvider2 = _interopRequireDefault(_SubscriptionProvider);

var _ContextProvider = require("./components/ContextProvider");

var _ContextProvider2 = _interopRequireDefault(_ContextProvider);

var _Notices = require("./components/Notices");

var _Notices2 = _interopRequireDefault(_Notices);

var _NewMessage = require("./components/NewMessage");

var _NewMessage2 = _interopRequireDefault(_NewMessage);

var _ChatRooms = require("./components/pages/ChatRooms");

var _ChatRooms2 = _interopRequireDefault(_ChatRooms);

var _ChatRoom = require("./components/pages/ChatRooms/ChatRoom");

var _ChatRoom2 = _interopRequireDefault(_ChatRoom);

var _Create = require("./components/pages/ChatRooms/ChatRoom/Create");

var _Create2 = _interopRequireDefault(_Create);

var _ChatMessages = require("./components/pages/ChatMessages");

var _ChatMessages2 = _interopRequireDefault(_ChatMessages);

var _ChatMessage = require("./components/pages/ChatMessages/ChatMessage");

var _ChatMessage2 = _interopRequireDefault(_ChatMessage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

exports.ContextProvider = _ContextProvider2.default;
exports.SubscriptionProvider = _SubscriptionProvider2.default;
exports.Notices = _Notices2.default;
exports.NewMessage = _NewMessage2.default;
exports.ChatRooms = _ChatRooms2.default;
exports.ChatRoom = _ChatRoom2.default;
exports.CreateChatRoom = _Create2.default;
exports.ChatMessages = _ChatMessages2.default;
exports.ChatMessage = _ChatMessage2.default;

var App = function (_PureComponent) {
  _inherits(App, _PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  App.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        other = _objectWithoutProperties(_props, ["children"]);

    return _react2.default.createElement("div", other, _react2.default.createElement("h2", null, "My awesome component"), children);
  };

  return App;
}(_react.PureComponent);

exports.default = App;